import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CycleCountLogDocumentFragment = { __typename?: 'CycleCountLogDocument', id: string, locationId: string, locationName: string, recordedBy: string, postedAt: Types.TDateISO, itemCount: number, idempotencyKey?: string | null, items: Array<{ __typename?: 'CycleCountLogItem', itemId: string, itemName: string, sku: string, quantity: number, note?: string | null, batches: Array<{ __typename?: 'CycleCountLogBatch', code?: string | null, quantity: number }> }> };

export type GetCycleCountHistoryQueryVariables = Types.Exact<{
  locationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  recordedBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  since?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCycleCountHistoryQuery = { __typename?: 'Query', cycleCountHistory?: { __typename?: 'CycleCountHistoryConnection', totalCount: number, nodes?: Array<{ __typename?: 'CycleCountLogDocument', id: string, locationId: string, locationName: string, recordedBy: string, postedAt: Types.TDateISO, itemCount: number, idempotencyKey?: string | null, items: Array<{ __typename?: 'CycleCountLogItem', itemId: string, itemName: string, sku: string, quantity: number, note?: string | null, batches: Array<{ __typename?: 'CycleCountLogBatch', code?: string | null, quantity: number }> }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetCycleCountRecordQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.CycleCountLogDocumentFilterInput>;
  since?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type GetCycleCountRecordQuery = { __typename?: 'Query', cycleCountHistory?: { __typename?: 'CycleCountHistoryConnection', totalCount: number, nodes?: Array<{ __typename?: 'CycleCountLogDocument', id: string, locationId: string, locationName: string, recordedBy: string, postedAt: Types.TDateISO, itemCount: number, idempotencyKey?: string | null, items: Array<{ __typename?: 'CycleCountLogItem', itemId: string, itemName: string, sku: string, quantity: number, note?: string | null, batches: Array<{ __typename?: 'CycleCountLogBatch', code?: string | null, quantity: number }> }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const CycleCountLogDocumentFragmentDoc = new TypedDocumentString(`
    fragment CycleCountLogDocument on CycleCountLogDocument {
  id
  locationId
  locationName
  recordedBy
  postedAt
  itemCount
  idempotencyKey
  items {
    itemId
    itemName
    sku
    quantity
    note
    batches {
      code
      quantity
    }
  }
}
    `, {"fragmentName":"CycleCountLogDocument"});
export const GetCycleCountHistoryDocument = new TypedDocumentString(`
    query GetCycleCountHistory($locationId: String, $recordedBy: String, $since: DateTime, $first: Int, $after: String) {
  cycleCountHistory(
    locationId: $locationId
    recordedBy: $recordedBy
    since: $since
    first: $first
    after: $after
  ) {
    nodes {
      ...CycleCountLogDocument
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    fragment CycleCountLogDocument on CycleCountLogDocument {
  id
  locationId
  locationName
  recordedBy
  postedAt
  itemCount
  idempotencyKey
  items {
    itemId
    itemName
    sku
    quantity
    note
    batches {
      code
      quantity
    }
  }
}`);
export const GetCycleCountRecordDocument = new TypedDocumentString(`
    query GetCycleCountRecord($first: Int, $where: CycleCountLogDocumentFilterInput, $since: DateTime) {
  cycleCountHistory(first: $first, since: $since, where: $where) {
    nodes {
      ...CycleCountLogDocument
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment CycleCountLogDocument on CycleCountLogDocument {
  id
  locationId
  locationName
  recordedBy
  postedAt
  itemCount
  idempotencyKey
  items {
    itemId
    itemName
    sku
    quantity
    note
    batches {
      code
      quantity
    }
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCycleCountHistory: build.query<GetCycleCountHistoryQuery, GetCycleCountHistoryQueryVariables | void>({
      query: (variables) => ({ document: GetCycleCountHistoryDocument, variables })
    }),
    GetCycleCountRecord: build.query<GetCycleCountRecordQuery, GetCycleCountRecordQueryVariables | void>({
      query: (variables) => ({ document: GetCycleCountRecordDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCycleCountHistoryQuery, useLazyGetCycleCountHistoryQuery, useGetCycleCountRecordQuery, useLazyGetCycleCountRecordQuery } = injectedRtkApi;
